// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mirror[data-v-1f087028] {
    transform: scaleX(-1);
}
#leave_btn[data-v-1f087028] {
    bottom: 15px;
}
.video-full-height[data-v-1f087028] {
    height: calc(100vh - 136px);
    max-height: calc(100vh - 136px);
}
.video-two-thirds-height[data-v-1f087028] {
    height: calc(67vh - 136px);
    max-height: calc(100vh - 136px);
}
.video-half-height[data-v-1f087028] {
    height: calc(50vh - 78px);
    max-height: calc(50vh - 78px);
}
.video-fourth-height[data-v-1f087028] {
    height: calc(25vh - 38px);
}
.video-third-small-height[data-v-1f087028] {
    height: calc(30vh - 46px);
}
.video-third-large-height[data-v-1f087028] {
    height: calc(39vh - 46px);
}
.video-third-height[data-v-1f087028] {
    height: calc(33vh - 46px);
}
.video-quarter-height[data-v-1f087028] {
    height: calc(25vh - 38px);
}
.video-fifth-height[data-v-1f087028] {
    height: calc(20vh - 30px);
}
.video-sixth-height[data-v-1f087028] {
    height: calc(16vh - 17px);
}
.video-five-sixths-height[data-v-1f087028] {
    height: calc(16vh - 155px);
}
.video-eighth-height[data-v-1f087028] {
    height: calc(12vh - 12px);
}
.translate-half[data-v-1f087028] {
    transform:translateY(20vh);
}
.translate-third[data-v-1f087028] {
    transform:translateY(15vh);
}
.translate-fourth[data-v-1f087028] {
    transform:translateY(10vh);
}
.hello_name[data-v-1f087028] {
    -webkit-text-decoration: double !important;
            text-decoration: double !important;
    border: 1px dotted;
    padding: 0 8px;
    border-radius: 10px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
